module.exports = __webpack_public_path__ + "img/skull_advantages_bj.beb56a02.png";